module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_11.67774547.webp";